import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import {TiersValidatorBuilder} from 'services/validations/builders/tiers-validator-builder';

export default class UserAdjustmentsValidatorTiersBuilder extends BaseExecutor {
    getInterface() {
        const validator = new BaseValidator();

        const tiersValidatorBuilder = new TiersValidatorBuilder().getInterface();
        validator.addSubValidators([tiersValidatorBuilder]);

        if (this._isAnyStackingUsed()) {
            return validator;
        }

        const {userPointsType} = Action.getState();

        const minAdjustedPlayersValidatorBuilder = new MinAdjustedPlayersValidatorBuilder({
            propNameOfDefaultUserPointsValue: userPointsType.getUserPointsType(),
        }).getInterface();

        validator.addSubValidators([minAdjustedPlayersValidatorBuilder]);

        return validator;
    }

    _isAnyStackingUsed() {
        return (
            this._isPlayerNameStackingUsed() ||
            this._isPlayerCombinationStackingUsed() ||
            this._isProjectionBoostRuleUsed()
        );
    }

    _isPlayerNameStackingUsed() {
        const {playerNameStacking} = Action.getState();

        return playerNameStacking.isEnabled() && playerNameStacking.hasItems();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }

    _isProjectionBoostRuleUsed() {
        const {projectionBoostRule} = Action.getState();

        return projectionBoostRule.isEnabled() && projectionBoostRule.hasItems();
    }
}
